module.exports = [{"title":"Title 1","description":"this is promotion's description test","linkTitle":"link title","linkUrl":"https://youtube.com","backgroundImage":"https://www.cdacollaborative.org/wp-content/uploads/2016/01/Project-Carousel-Background-Biz-and-Peace.png"},{"title":"Title 2","titleIcon":"/static/img/specials/us_open.png","description":"this is promotion's description test","linkTitle":"link title","linkUrl":"https://youtube.com","backgroundImage":"https://www.cdacollaborative.org/wp-content/uploads/2016/01/Project-Carousel-Background-Biz-and-Peace.png"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/promotionPads.json
// module id = 2031
// module chunks = 0